module.exports = __webpack_public_path__ + "img/bio-purple-5.353155a.jpg";